var React = require('react');

function Account (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.196 21.4172C17.9586 21.4172 19.1631 19.7249 18.5003 18.1778C17.1431 15.0027 13.8484 12.7614 10 12.7614C6.15162 12.7614 2.85836 15.0013 1.49975 18.1778C0.836911 19.7264 2.0414 21.4172 3.80399 21.4172H16.196Z","strokeWidth":"1.59601","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M9.99998 10.1788C12.3981 10.1788 14.3421 8.23475 14.3421 5.83665C14.3421 3.43855 12.3981 1.49451 9.99998 1.49451C7.60188 1.49451 5.65784 3.43855 5.65784 5.83665C5.65784 8.23475 7.60188 10.1788 9.99998 10.1788Z","strokeWidth":"1.59601","strokeMiterlimit":"10","key":1})]);
}

Account.defaultProps = {"viewBox":"0 0 20 23","fill":"none"};

module.exports = Account;

Account.default = Account;
